import {
	GET_ALARM_EVENTS,
	GET_ALARM_EVENTS_FAIL,
	GET_ALARM_EVENTS_SUCCESS,
} from '../../constants/maintenance/alarmEventsConstants';

/**
 * Reducer function for managing alarm events list.
 *
 * @param {object} state - Current state of the alarm events list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */

export const alarmEventsReducer = (state = { alarmEvents: [] }, action) => {
	switch (action.type) {
		case GET_ALARM_EVENTS:
			return {
				...state,
				loading: true,
			};
		case GET_ALARM_EVENTS_SUCCESS:
			return {
				...state,
				loading: false,
				alarmEvents: action.payload,
			};
		case GET_ALARM_EVENTS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
